import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import each from 'lodash/each';
import isUndefined from 'lodash/isUndefined';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { makeStyles, Button } from '@material-ui/core';

import { getI18n } from "../../../utils/intl";
import FormTextField from '../../FormTextField';

import styles from './styles';

const FilterByValueList = (props) => {
  const {
    valuesHeading, validate, updateSelectedItems,
    isGrouped, validationError, duplicateError,
  } = props;

  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const [state, updateState] = useState({
    disableAddBtn: props.values.length === 0,
    values: props.values.length ? props.values : [''],
    dirtyCheck: [],
    valueCounter: [],
  });

  const setState = (value) => {
    if (typeof value === 'function') {
      updateState(currentValue => ({ ...currentValue, ...value(state) }));
    } else {
      updateState(currentValue => ({ ...currentValue, ...value }));
    }
  }

  useEffect(() => {
    const dirtyCheck = [];
    const valueCounter = [];
    if (props.values && props.values.length) {
      each(props.values, (val, index) => {
        dirtyCheck[index] = true;
        valueCounter[index] = val;
      });
      setState({ dirtyCheck, valueCounter });
    }
  }, []);

  const handleChange = (value, index) => {
    const { values, dirtyCheck } = state;
    values[index] = value;
    dirtyCheck[index] = true;
    const valueCounter = updateValueCounter(index, value);
    setState({
      values,
      disableAddBtn: !checkToEnableAddBtn(values) || isDuplicate(valueCounter, value),
      dirtyCheck,
    });
    updateSelectedItems(values);
  };

  const addValue = () => {
    const values = state.values || [];
    values.push('');
    setState({
      values,
      disableAddBtn: true,
    });
    updateSelectedItems(values);
  };

  const checkToEnableAddBtn = (values) => {
    let enableAddBtn = true;
    each(values, (value) => {
      enableAddBtn = enableAddBtn && validate(value);
    });
    return enableAddBtn;
  };

  const removeValue = index => {
    let { values, dirtyCheck } = state;
    const val = values[index];
    const valueCounter = updateValueCounter(index);
    values = values.filter((_, i) => i !== index);
    dirtyCheck = dirtyCheck.filter((_, i) => i !== index);
    setState({
      values,
      disableAddBtn: !checkToEnableAddBtn(values) || isDuplicate(valueCounter, val),
      dirtyCheck,
    });
    updateSelectedItems(values);
  };

  const updateValueCounter = (index, value) => {
    let { valueCounter } = state;
    if (!isUndefined(index)) {
      if (!isUndefined(value)) {
        valueCounter[index] = value;
      } else {
        valueCounter = valueCounter.filter((_, i) => i !== index);
      }
    }
    setState({ valueCounter });
    return valueCounter;
  };

  const isDuplicate = (valueCounter, value) => {
    let dupFlag = false;
    if (!isUndefined(valueCounter) && !isUndefined(value)) {
      const filteredValues = valueCounter.filter((val) => val === value);
      dupFlag = filteredValues && filteredValues.length > 1;
    }
    return dupFlag;
  };

  const renderTextInput = (val, index) => (
    <FormTextField
      hideLabel
      name={`valueField-${index}`}
      id={`valueField-${index}`}
      key={`inputKey-${index}`}
      className={classes.textInput}
      fieldContainerClass={classes.valueField}
      handleChange={(value) => handleChange(value, index)}
      labelClass={classes.textFieldLabel}
      value={val}
      type={'number'}
      autoComplete="off"
    />
  );

  const { values, dirtyCheck, valueCounter, disableAddBtn } = state;
  return (
    <div className={classes.filterByValueContainer}>
      <div className={classes.containerSpacing}>
        <div className={classes.label}>
          {intl.getI18nMessage(valuesHeading)}
        </div>
        { values.length ? values.map((val, index) => (
          <div className={classes.valueContainer} key={index}>
            <div
              className={clsx(classes.textBox,
                dirtyCheck[index] && !validate(val) ?
                classes.textAndError : '')}
            >
              {renderTextInput(val, index)}
              { values.length > 1 &&
                <Button
                  className={classes.removeValueButton}
                  onClick={() => removeValue(index)}
                >
                  Remove
                </Button>
              }
            </div>
            { dirtyCheck[index] && !validate(val) &&
              <p className={classes.errorMessage}>
                {intl.getI18nMessage(validationError)}
              </p>
            }
            { validate(val) && isDuplicate(valueCounter, val) &&
              <p className={classes.errorMessage}>
                {intl.getI18nMessage(duplicateError)}
              </p>
            }
          </div>
        )) : null}
        { (values.length < 10 || isGrouped) &&
          <Button
            color="primary"
            disabled={disableAddBtn}
            onClick={addValue}
            variant="outlined"
          >
            Add Another
          </Button>
        }
      </div>
    </div>
  );
}

FilterByValueList.propTypes = {
  valuesHeading: PropTypes.string,
  validate: PropTypes.func,
  values: PropTypes.array,
  isGrouped: PropTypes.bool,
  validationError: PropTypes.string,
  duplicateError: PropTypes.string,
  updateSelectedItems: PropTypes.func,
};

export default FilterByValueList;